/* eslint-disable max-len */
export const pathfinderMessages = {
    'Pathfinder.chartAiApps.description':
        'Spotlighting the top 6 AI apps discovered in the last 30 days. Use the Shadow AI View to govern and optimize the use of AI-powered applications for efficient operations and company policy adherence.',
    'Pathfinder.chartAiApps.footer.label': 'Check more shadow AI apps',
    'Pathfinder.chartAiApps.title': 'AI Applications',

    'Pathfinder.chartAppClassificationStatus.description':
        'Classify apps promptly to strengthen compliance and reduce risk.',
    'Pathfinder.chartAppClassificationStatus.footer.label':
        'Review all unclassified apps',
    'Pathfinder.chartAppClassificationStatus.title':
        'App Classification Status',

    'Pathfinder.chartRecentlyDiscoveredApps.description':
        'Stay informed about new tools in use across the organization to ensure proper visibility, compliance, and cost management.',
    'Pathfinder.chartRecentlyDiscoveredApps.footer.label':
        'Review more new apps',
    'Pathfinder.chartRecentlyDiscoveredApps.title':
        'Recently Discovered Applications',

    'Pathfinder.chartShadowITApps.description':
        'We’ve highlighted the top six unclassified applications with elevated risk detected in the past 30 days. Use this chart and the Shadow IT View to review and classify potential shadow IT applications, helping to mitigate security risks and ensure policy compliance.',
    'Pathfinder.chartShadowITApps.footer.label': 'Check more shadow IT apps',
    'Pathfinder.chartShadowITApps.title': 'Shadow IT Applications',

    'Pathfinder.customShortcuts.title': 'Recommended Actions',

    'Pathfinder.entityHighRiskUsers.description':
        'Monitoring users introducing the highest number of new SaaS applications to help identify potential compliance risks, reduce shadow IT, and manage SaaS-related costs more effectively.',
    'Pathfinder.entityHighRiskUsers.footer.label': 'Discover App Usage by User',
    'Pathfinder.entityHighRiskUsers.title': 'High Risk Users',

    'Pathfinder.entityOverlappingTools.description':
        'Consolidate and optimize applications with similar functions for improved efficiency. This visualization includes personal apps.',
    'Pathfinder.entityOverlappingTools.footer.label': 'View Overlap Report',
    'Pathfinder.entityOverlappingTools.title': 'Overlapping Tools',

    'Pathfinder.entityUnderutilizedLicenses.description':
        'Identify inactive licenses to reduce unnecessary costs, and minimize security risks from dormant accounts.',
    'Pathfinder.entityUnderutilizedLicenses.title': 'Underutilized Licenses',

    'Pathfinder.groupApplicationsInsights.needsSetup.actions.completeSetup':
        'Complete setup',
    'Pathfinder.groupApplicationsInsights.needsSetup.actions.viewSetupGuide':
        'View setup guide',
    'Pathfinder.groupApplicationsInsights.needsSetup.content':
        '**Almost There! Complete Setup to Unlock Insights** <br/> <br/>To view insights, you’ll need to complete your setup. Once setup is finished, relevant data and trends will appear here to help you monitor and optimize your SaaS ecosystem.',
    'Pathfinder.groupApplicationsInsights.needsSetup.title':
        'Applications Insights',

    'Pathfinder.groupApplicationsInsights.title': 'Applications Insights',
    'Pathfinder.groupKpi.title': 'Inventory Overview',

    'Pathfinder.groupLicensesInsights.needsSetup.title': 'Licenses Insights',
    'Pathfinder.groupLicensesInsights.title': 'Licenses Insights',

    'Pathfinder.kpiNewActiveUsers.footer.label': 'Review users',
    'Pathfinder.kpiNewActiveUsers.title': 'Total Active Users',
    'Pathfinder.kpiNewApplications.footer.label': 'Review applications',
    'Pathfinder.kpiNewApplications.title': 'Total Applications Discovered',
    'Pathfinder.kpiNewDevicesDetected.footer.label': 'Review devices',
    'Pathfinder.kpiNewDevicesDetected.title': 'Total Devices Detected',

    'Pathfinder.tableHighRiskDownloads.description':
        'Identify and manage download activity from high-risk applications that may pose security or compliance threats.',
    'Pathfinder.tableHighRiskDownloads.footer.label': 'Review security logs',
    'Pathfinder.tableHighRiskDownloads.title': 'High Risk Downloads',

    'Pathfinder.tableLicensesWithUndetectedAccounts.description':
        'Identify licenses with no reported usage to reduce unnecessary costs.',
    'Pathfinder.tableLicensesWithUndetectedAccounts.title':
        'Licenses with Undetected Accounts',

    'Pathfinder.tableRecentEventLogs.description':
        'Highlights of recent activity across your environment, including newly discovered apps, credential usage (shared, service, personal), and first-time application use by users and tagged applications.',
    'Pathfinder.tableRecentEventLogs.footer.label': 'Create Alert',
    'Pathfinder.tableRecentEventLogs.title': 'Recent Events',

    'Pathfinder.tableRecentlyAddedApps.description':
        'Review recently added applications, helping you track new software adoption across your organization.',
    'Pathfinder.tableRecentlyAddedApps.footer.label': 'Review apps',
    'Pathfinder.tableRecentlyAddedApps.title': 'Apps Added in Last 30 Days',

    'Pathfinder.tableSharedCredentials.description':
        'Review users accessing applications using shared credentials to ensure compliance and mitigate data breach risks.',
    'Pathfinder.tableSharedCredentials.footer.label': 'Review security logs',
    'Pathfinder.tableSharedCredentials.title': 'Shared Credentials',

    'Pathfinder.tableSsoCoverage.description':
        'Enable and enforce SSO to enhance security, streamline user access, and improve compliance.',
    'Pathfinder.tableSsoCoverage.footer.label': 'Review SSO coverage',
    'Pathfinder.tableSsoCoverage.title': 'SSO Coverage'
};
